import { createContext } from "react";

export const FlowContext = createContext();
